import styled from '@emotion/styled'

export const RadioContainer = styled('div')<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid ${(props) => (props.disabled ? '#d9d9d9' : '#d9d9d9')};
  border-radius: 50%;
  background-color: ${(props) => (props.disabled ? '#f5f5f5' : '#ffffff')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  margin: 3px 0px;

  &:hover {
    border-color: ${(props) => (props.disabled ? '#d9d9d9' : '#009400')};
  }
`

export const RadioInner = styled('div')<{ checked: boolean; disabled?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => {
    if (props.disabled) return props.checked ? '#d9d9d9' : 'transparent'
    return props.checked ? '#009400' : 'transparent'
  }};
  transition: all 0.2s ease;
  transform: ${(props) => (props.checked ? 'scale(1)' : 'scale(0)')};
`
